import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import Select from "react-select";
import classnames from "classnames";
import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import {Input} from "reactstrap";
import {injectIntl} from "react-intl";

class PresentationDropdown extends Component {

  constructor(props) {
    super(props);

    this.isOpen = this.isOpen.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.onItemSelect = this.onItemSelect.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
  }

  isOpen(){
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    if(!detail){
      return false;
    }

    return this.props.answers.find(answer => answer.id === detail.answer).isOpen;
  }

  onOpenChange(e){
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    detail.content = e.target.value;
    detail.microTime = getCurrentMicroTime(this.props.startTime);

    this.props.onDetailsUpdated([detail]);
  }

  onItemSelect(option){
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    if(detail && detail.answer === option.value){
      return;
    }

    const microTime = getCurrentMicroTime(this.props.startTime);
    this.props.onDetailsUpdated([{
      answer: option.value,
      microTime,
      content: null,
    }]);

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (option) { " + javascript.code + " }")().bind(this);
        func(option);
      }
    });
  }

  filterOptions(option, searchText) {
    const content = this.props.answers.find(answer => answer.id === option.value).content;
    return String(option.value).includes(searchText) || content.toLowerCase().includes(searchText.toLowerCase());
  }

  render() {
    const {answers, details, answersImage} = this.props;
    const detail = this.props.details.length === 0 ? false : this.props.details[0]

    let value = false;
    if(details.length > 0){
      const content = answers.find(answer => answer.id === details[0].answer).content;
      value = {
        value: details[0].answer,
        label: (answersImage ? <img src={content} /> : <div dangerouslySetInnerHTML={{__html: content}} />),
      };
    }

    return (
      <div class={classnames({
        "d-flex flex-column dropdown-container": true,
        "selected": value
      })}>
        <Select
          menuPlacement={"bottom"}
          maxMenuHeight={408}
          class={"dropdown-wrapper"}
          value={value}
          onChange={this.onItemSelect}
            placeholder={this.props.intl.formatMessage({id: 'question.dropdown.open'})}
          options={answers.map(answer => {
            return {
              value: answer.id,
              label: (answersImage ?
                <div className="container">
                  <div className="row">
                    <img src={answer.content} />
                    <div className="my-auto mx-auto">
                      {<span dangerouslySetInnerHTML={{__html: answer.description}} />}
                    </div>
                  </div>
                </div> : <span dangerouslySetInnerHTML={{__html: answer.content}} />),
            }
          })}
          isSearchable={this.props.isSearchable}
          filterOption={this.filterOptions}
        />

        {this.isOpen() && <div className="d-flex">
          <Input
            className={classnames({
              'mt-2': true,
            })}
            placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
            type="text"
            autoFocus={true}
            bsSize="sm"
            onChange={this.onOpenChange}
            value={detail.content || ''}
          /></div>}
      </div>
    )
  }
}

PresentationDropdown.propTypes = {
  question: PropTypes.shape({
    javascripts: PropTypes.array.isRequired,
  }).isRequired,
  answers: PropTypes.array.isRequired,
  answersImage: PropTypes.bool.isRequired,
  details: PropTypes.array.isRequired,
  isSearchable: PropTypes.bool.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(injectIntl(PresentationDropdown));
